/**
 * rail-scroll.js -- Generic horizontal rail scroll controller.
 *
 * Attach to any container with:
 *   [data-rail-scroll]           wrapper (section)
 *   [data-rail-scroll-track]     scrollable element
 *   [data-rail-scroll-prev]      prev button
 *   [data-rail-scroll-next]      next button
 *
 * Handles RTL, disabled state, and 85% viewport-width scroll steps.
 * Replaces the single-use buy-again.js with a reusable controller.
 */
(function () {
  'use strict';

  var containers = document.querySelectorAll('[data-rail-scroll]');
  if (!containers.length) return;

  var isRtl = document.documentElement.dir === 'rtl';

  containers.forEach(function (container) {
    /* Guard against double-init when multiple sections load this script */
    if (container.dataset.railScrollInit) return;
    container.dataset.railScrollInit = '1';

    var track   = container.querySelector('[data-rail-scroll-track]');
    var prevBtn = container.querySelector('[data-rail-scroll-prev]');
    var nextBtn = container.querySelector('[data-rail-scroll-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function updateButtons() {
      var atStart, atEnd;
      if (isRtl) {
        atStart = Math.abs(track.scrollLeft) <= 4;
        atEnd   = Math.abs(track.scrollLeft) >= track.scrollWidth - track.clientWidth - 4;
      } else {
        atStart = track.scrollLeft <= 4;
        atEnd   = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      }
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
    }

    function scrollBy(direction) {
      var amount = Math.max(track.clientWidth * 0.85, 280);
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', function () {
      scrollBy(isRtl ? 1 : -1);
    });
    nextBtn.addEventListener('click', function () {
      scrollBy(isRtl ? -1 : 1);
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });

    /* ---- Mouse drag-to-scroll ---- */
    var isDragging = false;
    var startX = 0;
    var scrollStart = 0;

    track.addEventListener('mousedown', function (e) {
      isDragging = true;
      startX = e.pageX;
      scrollStart = track.scrollLeft;
      track.style.cursor = 'grabbing';
      track.style.scrollSnapType = 'none';
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var dx = e.pageX - startX;
      track.scrollLeft = scrollStart - dx;
    });

    document.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      track.style.cursor = '';
      track.style.scrollSnapType = '';
    });

    updateButtons();
  });
})();
